import { SelectedFilterField } from '@cdw-ae/filter-bar-interfaces';
import { getRouterSelectors } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { APP_FILTERS_FEATURE_KEY } from './filter.reducer';
import { FilterState } from './filter.state';

export const selectFilterState = createFeatureSelector<FilterState>(
  APP_FILTERS_FEATURE_KEY
);

export const selectFilterBars = createSelector(
  selectFilterState,
  (state: FilterState) => state.filterBars
);

export const selectSelectedFilters = (filterBarId = 'default') =>
  createSelector(
    selectFilterBars,
    (filterBars: { [filterBarId: string]: SelectedFilterField[] }) =>
      filterBars[filterBarId] || []
  );

export const selectFilterSnapshotRef = (filterBarId = 'default') =>
  createSelector(
    selectFilterState,
    (state: FilterState) => state.filterSnapshotRefs?.[filterBarId] ?? null
  );

export const selectHasActiveFilters = (filterBarId = 'default') =>
  createSelector(
    selectFilterBars,
    (filterBars: { [filterBarId: string]: SelectedFilterField[] }) => {
      const filters = filterBars[filterBarId] || [];
      return filters.length > 0;
    }
  );

export const selectRouteConfig = createSelector(
  selectFilterState,
  (state: FilterState) => state.routeConfig
);

export const selectFilterBarSettings = createSelector(
  selectRouteConfig,
  (config) => config.filterBarSettings
);

export const selectCurrentConfig = createSelector(
  selectRouteConfig,
  (config) => config.urlParamConfig
);

export const selectNavigationConfig = createSelector(
  selectRouteConfig,
  (config) => config.navigationConfig
);
// Get router selectors
const routerSelectors = getRouterSelectors();

// export const selectCurrentRoute = routerSelectors.selectUrl;
export const selectQueryParams = routerSelectors.selectQueryParams;
export const selectRouteParams = routerSelectors.selectRouteParams;

export const selectCurrentRoute = createSelector(
  routerSelectors.selectUrl,
  (url) => url?.split('?')[0] || ''
);

export const selectIsLoading = createSelector(
  selectFilterState,
  (state: FilterState) => state.isLoading
);
